import { render, staticRenderFns } from "./Orari.vue?vue&type=template&id=218326a5"
import script from "./Orari.vue?vue&type=script&lang=js"
export * from "./Orari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports